import React, { useState } from "react";
import { Tabs, Tab, Box, Typography, Grid } from "@mui/material";

// Images
import teacherImg from "../assets/teacher.png";
import studentImg from "../assets/student.png";
import institutionImg from "../assets/academy.png";

// Icons for Tabs
import SchoolIcon from "@mui/icons-material/School";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import ApartmentIcon from "@mui/icons-material/Apartment";

export default function IntelliTutorForEveryone() {
  const [tab, setTab] = useState(0);

  const handleChange = (_, newVal) => setTab(newVal);

  const tabData = [
    {
      label: "For Teachers",
      icon: <SchoolIcon sx={{ mr: 1 }} />,
      image: teacherImg,
      title: "Empowering Teachers",
      description: (
        <>
          IntelliTutor helps teachers automate academic tasks while improving 
          classroom outcomes.
          <br /> <br />
          Teachers can upload materials, lecture notes, and set custom AI rules 
          to generate:
          <ul>
            <li>Smart summaries tailored to their syllabus</li>
            <li>Structured lesson plans</li>
            <li>AI-generated question papers with difficulty control</li>
            <li>Insights showing where students struggle the most</li>
          </ul>
          This allows teachers to spend more time teaching — not on paperwork.
        </>
      ),
    },
    {
      label: "For Students",
      icon: <EmojiPeopleIcon sx={{ mr: 1 }} />,
      image: studentImg,
      title: "Supporting Student Success",
      description: (
        <>
          IntelliTutor helps students learn smarter and faster by offering:
          <ul>
            <li>AI-powered explanations for any topic</li>
            <li>Instant practice questions & quizzes</li>
            <li>Personalized learning plans</li>
            <li>24/7 doubt-clearing assistance</li>
          </ul>
          Students gain confidence and clarity — anytime, anywhere.
        </>
      ),
    },
    {
      label: "For Institutions",
      icon: <ApartmentIcon sx={{ mr: 1 }} />,
      image: institutionImg,
      title: "Insights for Institutions",
      description: (
        <>
          Schools and universities gain deep insights into:
          <ul>
            <li>Student progress & performance trends</li>
            <li>AI usage analytics</li>
            <li>Curriculum alignment tracking</li>
            <li>Faculty efficiency improvements</li>
          </ul>
          IntelliTutor ensures quality digital learning across the institution.
        </>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", py: 8 }}>
      {/* Section Title */}
      <Typography
        variant="h4"
        sx={{ textAlign: "center", fontWeight: 700, mb: 5 }}
      >
        IntelliTutor is for Everyone
      </Typography>

      {/* TABS WITH ICONS */}
      <Tabs
        value={tab}
        onChange={handleChange}
        centered
        sx={{
          mb: 4,
          "& .MuiTab-root": {
            fontSize: "1.05rem",
            textTransform: "none",
            fontWeight: 600,
            minWidth: 180,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          },
          "& .Mui-selected": { color: "#1565c0" },
          "& .MuiTabs-indicator": { backgroundColor: "#1565c0" },
        }}
      >
        {tabData.map((item, i) => (
          <Tab key={i} icon={item.icon} label={item.label} />
        ))}
      </Tabs>

      {/* FIXED HEIGHT CONTENT AREA */}
      <Grid
        container
        spacing={4}
        direction={"row"}
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          alignItems: "center",
          minHeight: "520px", // ★ FIXED HEIGHT
          display:"flex",
          justifyContent:"space-between"
        }}
      >
        {/* Left Text Section */}
        <Grid item xs={12} md={6} sx={{minHeight:"500px"}}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2,textAlign: "left" }}>
            {tabData[tab].title}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: "1.15rem",
              lineHeight: 1.8,
              color: "#444",
              textAlign: "left", // ★ FIXED ALIGNMENT
            }}
          >
            {tabData[tab].description}
          </Typography>
        </Grid>

        {/* Right Image Section */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ minHeight:"500px"}}
        >
          <Box
            component="img"
            src={tabData[tab].image}
            alt={tabData[tab].label}
            sx={{
              width: "100%",
              maxWidth: "400px",
              height: "100%",
              objectFit: "contain",
              
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
// import React, { useState } from "react";
// import {
//   Tabs,
//   Tab,
//   Box,
//   Typography,
//   Grid,
//   Fade,
// } from "@mui/material";

// import SchoolIcon from "@mui/icons-material/School";
// import PersonIcon from "@mui/icons-material/Person";
// import BusinessIcon from "@mui/icons-material/Business";

// import teacherImg from "../assets/teacher.png";
// import studentImg from "../assets/student.png";
// import institutionImg from "../assets/academy.png";

// export default function IntelliTutorForEveryone() {
//   const [tab, setTab] = useState(0);

//   const handleChange = (_, newVal) => setTab(newVal);

//   const tabData = [
//     {
//       label: "For Teachers",
//       icon: <SchoolIcon sx={{ mr: 1 }} />,
//       image: teacherImg,
//       title: "Empowering Teachers",
//       description: (
//         <>
//           IntelliTutor helps teachers automate academic tasks while improving classroom outcomes.
//           <br /><br />
//           Upload course materials, lecture notes, and set custom AI rules to generate:
//           <ul>
//             <li>Smart summaries tailored to your syllabus</li>
//             <li>Structured lesson plans</li>
//             <li>AI-generated question papers with difficulty control</li>
//             <li>Insights showing where students struggle</li>
//           </ul>
//           This enables teachers to spend more time on real teaching — not paperwork.
//         </>
//       ),
//     },
//     {
//       label: "For Students",
//       icon: <PersonIcon sx={{ mr: 1 }} />,
//       image: studentImg,
//       title: "Supporting Student Success",
//       description: (
//         <>
//           IntelliTutor helps students understand difficult concepts, practise effectively,
//           and reduce preparation time with:
//           <ul>
//             <li>AI-powered explanations for any topic</li>
//             <li>Instant practice questions & quizzes</li>
//             <li>Personalized learning plans</li>
//             <li>24/7 doubt-clearing support</li>
//           </ul>
//           Students gain confidence and clarity — anytime, anywhere.
//         </>
//       ),
//     },
//     {
//       label: "For Institutions",
//       icon: <BusinessIcon sx={{ mr: 1 }} />,
//       image: institutionImg,
//       title: "Insights for Institutions",
//       description: (
//         <>
//           Schools and universities gain access to advanced analytics:
//           <ul>
//             <li>Usage tracking of AI tools campus-wide</li>
//             <li>Student progress & performance insights</li>
//             <li>Curriculum alignment reports</li>
//             <li>Support for faculty with AI-powered teaching tools</li>
//           </ul>
//           IntelliTutor ensures scalable, responsible, and transparent AI adoption.
//         </>
//       ),
//     },
//   ];

//   return (
//     <Box sx={{ width: "100%", py: 10 }}>
//       {/* Header */}
//       <Typography
//         variant="h4"
//         sx={{ textAlign: "center", fontWeight: 700, mb: 4 }}
//       >
//         IntelliTutor is for Everyone
//       </Typography>

//       {/* Tabs */}
//       <Tabs
//         value={tab}
//         onChange={handleChange}
//         centered
//         sx={{
//           mb: 5,
//           "& .MuiTab-root": {
//             textTransform: "none",
//             fontSize: "1.1rem",
//             fontWeight: 600,
//             display: "flex",
//             flexDirection: "row",
//           },
//           "& .Mui-selected": { color: "#1565c0" },
//           "& .MuiTabs-indicator": { backgroundColor: "#1565c0" },
//         }}
//       >
//         {tabData.map((item, i) => (
//           <Tab
//             key={i}
//             icon={item.icon}
//             iconPosition="start"
//             label={item.label}
//           />
//         ))}
//       </Tabs>

//       {/* Main Container - FIXED HEIGHT */}
//       <Box
//         sx={{
//           maxWidth: "1300px",
//           mx: "auto",
//           p: 4,
//           borderRadius: "16px",
//           background: "#ffffff",
//           minHeight: "480px",  // <--- FIXED HEIGHT
//           display: "flex",
//           alignItems: "center",
//         }}
//       >
//         <Fade in timeout={500}>
//           <Grid container spacing={6} justifyContent="flex-start" direction={"row"} sx={{display:"flex",
//            justifyContent:"space-between"}}>
//             {/* TEXT LEFT */}
//             <Grid item xs={10} md={5}>
//               <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
//                 {tabData[tab].title}
//               </Typography>

//               <Typography
//                 variant="body1"
//                 sx={{
//                   fontSize: "1.15rem",
//                   lineHeight: 1.8,
//                   color: "#444",
//                   maxWidth: "90%",
//                 }}
//               >
//                 {tabData[tab].description}
//               </Typography>
//             </Grid>

//             {/* IMAGE RIGHT */}
//             <Grid
//               item
//               xs={10}
//               md={5}
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 height: "100%",
//               }}
//             >
//               <Box
//                 component="img"
//                 src={tabData[tab].image}
//                 alt={tabData[tab].label}
//                 sx={{
//                   width: "100%",
//                   maxWidth: "450px",
//                   objectFit: "contain",
//                   borderRadius: "12px",
//                 }}
//               />
//             </Grid>
//           </Grid>
//         </Fade>
//       </Box>
//     </Box>
//   );
// }
